
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";

export async function consoleGenerationList(
    console_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/console/${console_id}/generation/list${queryString}`
    );
}

export async function consoleGenerationGet(
    item_id: string
) {
    return await clientAxios.get(
        `admin/console/generation/${item_id}/show`
    );
}

export async function consoleGenerationCreate(
    console_id: string,
    payload: Partial<any>
) {
    return await clientAxios.post(
        `admin/console/${console_id}/generation/create`,
        payload
    );
}

export async function consoleGenerationDel(
    item_id: string,
) {
    return await clientAxios.del(
        `admin/console/generation/${item_id}/delete`,
    );
}
